export default {"src":"/_next/static/image/src/images/Footer/footer-google-play-button.ee76fe18907914c479b5439f6ddeeb2d.svg","height":56,"width":189};